import React, { useCallback } from 'react'
import { AssessmentDefDrawerStyles } from './Style'
import { Drawer } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getAssessmentDefFetch } from 'store/middlewares/assessment.crud'
import { queryClient as qc } from 'keys'
import { CacheProvider } from '@emotion/react'
import { cacheLtr } from 'styles/theme'
import { AssessmentDefPreview } from 'components/AssessmentPreview'

const AssessmentDefDrawer = (props) => {
    const { open, handleDrawer, assessmentDefId, categoryName } = props

    const assessmentDef = useQuery({
        queryKey: [qc.assessmentDef, assessmentDefId, "assessment-def-drawer"],
        queryFn: async () => {
            const { data } = await getAssessmentDefFetch({ id: assessmentDefId })
            return data
        },
        enabled: !!assessmentDefId
    })

    const closeDrawer = useCallback(() => {
        handleDrawer(false)
    }, [assessmentDefId])

    return (
        <CacheProvider value={cacheLtr}>
            <Drawer open={open} onClose={closeDrawer}>
                <AssessmentDefDrawerStyles role="presentation" onClick={closeDrawer}>
                    <AssessmentDefPreview
                        data={assessmentDef?.data}
                        categoryName={categoryName}
                        onClose={closeDrawer}              

                    />
                </AssessmentDefDrawerStyles>
            </Drawer>
        </CacheProvider>
    )
}

export default AssessmentDefDrawer
